import { Update } from "./updateUrl";

export const SET_UPDATE_URL = async ({ CSP }) => {
  if (CSP === "DT") {
    Update.ANDROIDstoreURL = "market://details?id=com.daitonn.daitonnonline";
    Update.IOSstoreURL =
      "itms-apps://itunes.apple.com/us/app/apple-store/id1574661421?mt=8";
  } else if (CSP === "AV") {
    Update.ANDROIDstoreURL = "market://details?id=com.daitonn.avasfood";
    Update.IOSstoreURL =
      "itms-apps://itunes.apple.com/us/app/apple-store/id1487298861?mt=8";
      // "itms-apps://itunes.apple.com/us/app/apple-store/id1487298861;"
  } else if (CSP === "MK") {
    Update.ANDROIDstoreURL = "market://details?id=com.daitonn.mkb";
    Update.IOSstoreURL =
      "itms-apps://itunes.apple.com/us/app/apple-store/id1589199753?mt=8";
  }
};
